<template>
    <div id="TrainerLogin">
        <div class="section">
            <div class="row">
                <div class="col s10 offset-s1 m8 offset-m2 l6 offset-l3">
                    <h3>Login</h3>
                </div>
                <div class="col s10 offset-s1 m8 offset-m2 l6 offset-l3">
                    <form action="index.html">
                        <div class="input-field">
                            <i class="material-icons prefix">email</i>
                            <input type="email" id="email" v-model.trim="email">
                            <label for="email">E-Mail</label>
                        </div>
                        <div class="input-field">
                            <i class="material-icons prefix">lock</i>
                            <input type="password" id="password" v-model="password">
                            <label for="password">Password</label>
                        </div>
                        <button v-on:click="login" class="btn btn-medium btn-extended">Login</button>
                    </form>
                </div>
            </div>

            <!-- Registration (temporary disabled) -->

            <!-- <div class="row">
                <div class="col s10 offset-s1 m8 offset-m2 l6 offset-l3">
                    <span>Noch keinen Account? <router-link to="/TrainerRegister">Registrieren</router-link></span>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>

import firebase from 'firebase';

export default {
    name: 'TrainerLogin',
    data() {
        return{
            email:'',
            password:'',
        };
    },
    methods: {
        login: function(event) {
            firebase
            .auth()
            .signInWithEmailAndPassword(this.email, this.password)
            .then(
                user => {
                    alert('You are logged in as ' + user.user.email);
                    this.$router.push('/');
                },
                err => {
                    alert(err.message);
                }
            );
            event.preventDefault();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/TrainerLogin.vue